import * as React from "react";
import Link from 'gatsby-link';
import * as staticUrls from "../../constants/static-urls";
import * as pricingData from "../../constants/pricing-data";
import styled from "styled-components";

interface PricingInfoPackageSwitchBlockProps {
  onButtonClick: () => any
  onLinkClick: () => any
}

interface PricingInfoPackageSwitchBlockState {
  monthlyPackageSelected: boolean
  quarterlyPackageSelected: boolean
  halfyearlyPackageSelected: boolean
  yearlyPackageSelected: boolean
  packagePrice: string
}

class PricingInfoPackageSwitchBlock extends React.Component<PricingInfoPackageSwitchBlockProps,PricingInfoPackageSwitchBlockState> {

  constructor(props: PricingInfoPackageSwitchBlockProps) {
    super(props);
    this.state = {
      monthlyPackageSelected: true,
      quarterlyPackageSelected: false,
      halfyearlyPackageSelected: false,
      yearlyPackageSelected: false,
      packagePrice: pricingData.getMonthlyPackagePricing(
        true,
        false,
        false,
        false,
      )
    };
    this.selectMonthlyPackage = this.selectMonthlyPackage.bind(this);
    this.selectQuarterlyPackage = this.selectQuarterlyPackage.bind(this);
    this.selectHalfyearlyPackage = this.selectHalfyearlyPackage.bind(this);
    this.selectYearlyPackage = this.selectYearlyPackage.bind(this);
  }

  selectMonthlyPackage(event: any) {
    this.setState({
      monthlyPackageSelected: true,
      quarterlyPackageSelected: false,
      halfyearlyPackageSelected: false,
      yearlyPackageSelected: false,
      packagePrice: pricingData.getMonthlyPackagePricing(
        true,
        false,
        false,
        false,
      ),
    });
  }

  selectQuarterlyPackage(event: any) {
    this.setState({
      monthlyPackageSelected: false,
      quarterlyPackageSelected: true,
      halfyearlyPackageSelected: false,
      yearlyPackageSelected: false,
      packagePrice: pricingData.getMonthlyPackagePricing(
        false,
        true,
        false,
        false,
      ),
    });
  }

  selectHalfyearlyPackage(event: any) {
    this.setState({
      monthlyPackageSelected: false,
      quarterlyPackageSelected: false,
      halfyearlyPackageSelected: true,
      yearlyPackageSelected: false,
      packagePrice: pricingData.getMonthlyPackagePricing(
        false,
        false,
        true,
        false,
      )
    });
  }

  selectYearlyPackage(event: any) {
    this.setState({
      monthlyPackageSelected: false,
      quarterlyPackageSelected: false,
      halfyearlyPackageSelected: false,
      yearlyPackageSelected: true,
      packagePrice: pricingData.getMonthlyPackagePricing(
        false,
        false,
        false,
        true,
      ),
    });
  }

  render() {
    const {onButtonClick,onLinkClick} = this.props;
    const {
      monthlyPackageSelected,
      quarterlyPackageSelected,
      halfyearlyPackageSelected,
      yearlyPackageSelected,
      packagePrice,
    } = this.state;

    // KLASY DO AKTYWNYCH GUZIKÓW
    const monthlyButtonClass = monthlyPackageSelected ? 'blue' : 'grey';
    const quarterlyButtonClass = quarterlyPackageSelected ? 'blue' : 'grey';
    const halfyearlyButtonClass = halfyearlyPackageSelected ? 'blue' : 'grey';
    const yearlyButtonClass = yearlyPackageSelected ? 'blue' : 'grey';

    return (
      <CardWrapper className="card">
        <div className="card-content white-text">
          <CardTitleWrapper className="card-title">Pełna księgowość online</CardTitleWrapper>

          <PackageSelectorContainer>
            <PackageSelectorButton
              className={`waves-effect waves-light btn ${monthlyButtonClass}`}
              onClick={this.selectMonthlyPackage}
            >
              MIESIĘCZNIE
            </PackageSelectorButton>
            <PackageSelectorButton
              className={`waves-effect waves-light btn ${quarterlyButtonClass}`}
              onClick={this.selectQuarterlyPackage}
            >
              KWARTALNIE
            </PackageSelectorButton>
          </PackageSelectorContainer>

          <PackageSelectorContainer>
            <PackageSelectorButton
              className={`waves-effect waves-light btn ${halfyearlyButtonClass}`}
              onClick={this.selectHalfyearlyPackage}
            >
              PÓŁROCZNIE
            </PackageSelectorButton>
            <PackageSelectorButton
              className={`waves-effect waves-light btn ${yearlyButtonClass}`}
              onClick={this.selectYearlyPackage}
            >
              ROCZNIE
            </PackageSelectorButton>
          </PackageSelectorContainer>

          <PriceInfoContainer>
            <PriceValueWrapper>{packagePrice}</PriceValueWrapper>
            <PriceInfoWrapper>zł / m-c</PriceInfoWrapper>
          </PriceInfoContainer>

          <CallToActionContainer>
            <CallToActionButtonWrapper
              className="waves-effect waves-light btn blue"
              href={staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL}
              target="_blank"
              onClick={onButtonClick}
            >
              Wypróbuj bezpłatnie
            </CallToActionButtonWrapper>
          </CallToActionContainer>

          <FeatureListContainer className="features-list">
            <div className="col-sm-6 col-xs-12">
              <ul className="check-circle-list">
                <li><i className="fa fa-check-square mr-10"></i> Fakturowanie</li>
                <li><i className="fa fa-check-square mr-10"></i> CRM</li>
                <li><i className="fa fa-check-square mr-10"></i> Księgowość online</li>
                <li><i className="fa fa-check-square mr-10"></i> E-deklaracje, JPK i KSeF</li>
                <li><i className="fa fa-check-square mr-10"></i> Kasa / Bank</li>
              </ul>
            </div>
            <div className="col-sm-6 col-xs-12">
              <ul className="check-circle-list">
                <li><i className="fa fa-check-square mr-10"></i> Sprawozdania finansowe</li>
                <li><i className="fa fa-check-square mr-10"></i> Wzorce dokumentów</li>
                <li><i className="fa fa-check-square mr-10"></i> Rozliczenia kadrowe</li>
                <li><i className="fa fa-check-square mr-10"></i> Analizy finansowe</li>
                <li><i className="fa fa-check-square mr-10"></i> Pomoc księgowego</li>
              </ul>
            </div>
          </FeatureListContainer>
        </div>
        <CardFooterWrapper className="card-action">
          <p>Podane ceny są cenami netto.</p>
          <Link to={staticUrls.FAKTUROMANIA_POROWNANIE_PAKIETOW_PAGE_URL} onClick={onLinkClick}>Porównanie pakietów</Link>
        </CardFooterWrapper>
      </CardWrapper>
    )
  }

}

/** STYLES */

/** CARD */

const CardWrapper = styled.div`
  flex-basis: 50%;
  overflow: visible !important;
`;

const CardTitleWrapper = styled.span`
  color: #424242 !important;
  text-align: center !important;
  font-weight: bold !important;
  display: block;
  font-size: 35px !important;
`;

const CardFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  text-align: center;
  p {
    margin: 0;
  }
  a {
    margin-top: -5px;
    margin-right: 0 !important;
    text-transform: none !important;
    color: #1976d2 !important;
    text-decoration: underline;
  }
`;

/** PRICING INFO */

const PriceInfoContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-top: 20px;
`;

const PriceValueWrapper = styled.span`
  color: #1976d2;
  font-size: 35px;
  font-weight: 300;
  margin-right: 6px;
`;

const PriceInfoWrapper = styled.span`
  color: #4c5a72;
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
`;

/** PACKAGE SELECTOR CONTAINER */

const PackageSelectorContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 7px;
  margin-bottom: 0px !important;
  .btn, .btn-large, .btn-flat {
    margin-bottom: 5px !important;
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
`;

const PackageSelectorButton = styled.div`
  color: #FFF !important;
`;

/** CALL TO ACTION */

const CallToActionContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;  
`;

const CallToActionButtonWrapper = styled.a`
  color: #FFF !important;
`;

/** FEATURES LIST */

const FeatureListContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 25px;
  text-align: center;
  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: center;
    ul {
      padding-left: 20px !important;
      width: 200px;
      margin 0 auto !important;
    }
  }
  ul {
    color: #4d4d4d;
    font-size: 14px;
    font-weight: 300;
    line-height: 28px;
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }
  i {
    margin-right: 6px;
  }
  div.col-sm-6 {
    display: flex;
    justify-content: center;
  }
`;

export default PricingInfoPackageSwitchBlock


// WEBPACK FOOTER //
// ./src/layouts/pricing-info-block/pricing-info-package-switch-block.tsx